var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{on:{"cotentLoading":_vm.cotentLoading,"showNotification":_vm.notifyVue,"forceRerenderMenu":_vm.forceRerenderMenu,"setActiveTab":_vm.setActiveTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }